export const AvailablePayments = ['card_credit', 'card_debit', 'money']